/*
 * @Author: YuanYuan
 * @Date: 2024-09-14 17:25:19
 * @LastEditTime: 2025-07-11 18:29:00
 * @Description: 证书管理接口集合
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'tableQuery',
    path: `${prefix}/certificate/list`,
    method: 'get',
    params: {
      page: 1,
      limit: 10,
      name: '',
      authDomain: '',
      relateDomain: '',
      expireDateSort: ''
    },
    desc: '证书管理列表'
  },
  {
    name: 'custCertList',
    path: `${prefix}/certificate/getCustCertList`,
    method: 'get',
    params: {
      domain: ''
    },
    desc: '获取域名证书列表'
  },
  {
    name: 'certDetails',
    path: `${prefix}/certificate/get`,
    method: 'get',
    params: {
      certificateId: ''
    },
    desc: '查看证书详情'
  },
  {
    name: 'associatedDel',
    path: `${prefix}/certificate/deleteRelatedDomain`,
    method: 'post',
    params: {
      certificateId: '',
      domain: ''
    },
    desc: '证书关联域名删除'
  },
  {
    name: 'associatedQuery',
    path: `${prefix}/certificate/getRelatedDomainList`,
    method: 'get',
    params: {
      certificateId: ''
    },
    desc: '证书关联域名查询'
  },
  {
    name: 'uploadParse',
    path: `${prefix}/certificate/analysis`,
    method: 'post',
    params: {},
    desc: '解析上传的证书文件内容'
  },
  {
    name: 'preDeployDomains',
    path: `${prefix}/certificate/predeployRelatedDomain`,
    method: 'post',
    params: {
      certificateId: '',
      domain: ''
    },
    desc: '证书关联域名预部署'
  },
  {
    name: 'deployDomains',
    path: `${prefix}/certificate/deployRelatedDomain`,
    method: 'post',
    params: {
      certificateId: '',
      domain: ''
    },
    desc: '证书关联域名部署'
  },
  {
    name: 'certDel',
    path: `${prefix}/certificate/delete`,
    method: 'get',
    params: {
      certificateId: ''
    },
    desc: '删除证书'
  },
  {
    name: 'certSave',
    path: `${prefix}/certificate/save`,
    method: 'post',
    params: {
      name: '',
      comment: '',
      sslCertificate: '',
      sslKey: '',
      sslCertificateChain: '',
      certificateId: '',
      password: ''
    },
    desc: '提交新增证书'
  },
  {
    name: 'certApply',
    path: `${prefix}/certificate/addCertOrder`,
    method: 'post',
    params: {
      certName: '',
      domain: '',
      isAutoValid: '',
      isAutoRenew: ''
    },
    desc: '一键证书申请'
  },
  {
    name: 'recordQuery',
    path: `${prefix}/certificate/getCertOrderList`,
    method: 'get',
    params: {
      page: 1,
      limit: 10,
      domain: '',
      status: ''
    },
    desc: '申请记录查询'
  },
  {
    name: 'recordDetails',
    path: `${prefix}/certificate/getCertOrder`,
    method: 'get',
    params: {
      salesOrderId: ''
    },
    desc: '申请记录详情'
  },
  {
    name: 'cancelApply',
    path: `${prefix}/certificate/cancelCertOrder`,
    method: 'get',
    params: {
      salesOrderId: ''
    },
    desc: '取消申请'
  },
  {
    name: 'validInfo',
    path: `${prefix}/certificate/getCertDomainValidInfo`,
    method: 'get',
    params: {
      salesOrderId: ''
    },
    desc: '获取验证记录值'
  },
  {
    name: 'validateDNS',
    path: `${prefix}/certificate/validateDomainDNS`,
    method: 'get',
    params: {
      validateContent: '',
      domain: ''
    },
    desc: '验证DNS'
  },
  {
    name: 'batchRenew',
    path: `${prefix}/certificate/renew`,
    method: 'post',
    params: {
      certificateIds: '',
      isAuto: ''
    },
    desc: '批量续费和批量取消续费'
  }
]
